import { Box, Select } from "@mantine/core";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { TFunction } from "react-i18next";
import { colors } from "theme";

import Button from "components/Button";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { authoritiesInterventionAtom } from "atoms/accidentInformation";
import { authoritiesPhotosAtom } from "atoms/authoritiesPhotos";
import { vandalismSeverityAtom } from "atoms/vandalismSeverity";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useDigitalJourneyPageRouting } from "hooks/useDigitalJourneyPageRouting";
import { useEventTracking } from "hooks/useEventTracking";
import { AuthoritiesIntervention, VandalismSeverity } from "types/DigitalJourneySession";

import { getAuthoritiesInvolved } from "./DJAccidentInformationPage";

export const getVandalismSeverity = (t: TFunction) => {
  return [
    {
      label: "Furto parziale",
      value: VandalismSeverity.PARTIAL_THEFT,
    },
    {
      label: "Furto totale",
      value: VandalismSeverity.TOTAL_THEFT,
    },
    {
      label: "Incendio parziale",
      value: VandalismSeverity.PARTIAL_FIRE,
    },
    {
      label: "Incendio totale",
      value: VandalismSeverity.TOTAL_FIRE,
    },
    {
      label: "Atti Vandalici",
      value: VandalismSeverity.VANDALISM,
    },
  ];
};

export const DJTypeOfClaimTheftFire = () => {
  const { t } = useClientTranslation();
  const { trackEvent } = useEventTracking();
  const { onNext, continueCTA } = useDigitalJourneyPageRouting();
  const [authoritiesIntervention, setAuthoritiesIntervention] = useAtom(authoritiesInterventionAtom);
  const [vandalismSeverity, setVandalismSeverity] = useAtom(vandalismSeverityAtom);
  const setAuthoritiesPhotos = useSetAtom(authoritiesPhotosAtom);

  const isDisabled = authoritiesIntervention === null || vandalismSeverity === null;

  const onContinue = () => {
    trackEvent({ name: "Digital Journey Type of Claim Fire Theft Vandalism - continue" });
    if (authoritiesIntervention === AuthoritiesIntervention.NO) {
      setAuthoritiesPhotos([]);
    }
    onNext();
  };

  return (
    <PageLayout contentSpacing="space-between">
      <Flex px={24} py={24} gap={16} flex={1} mb={16}>
        <Text as="h1" sizeVariant="xl" weight={600}>
          Informazioni sul sinistro
        </Text>
        <Box>
          <Flex gap={16} role="radiogroup" aria-labelledby="typeOfClaim">
            <Select
              name="authoritiesIntervention"
              label={t("digital_journey.accident_information.authorities_involved_question")}
              placeholder={t("digital_journey.accident_information.select")}
              data={getAuthoritiesInvolved(t)}
              value={authoritiesIntervention}
              onChange={(value) => setAuthoritiesIntervention(value as AuthoritiesIntervention)}
            />
            <Select
              name="vandalismSeverity"
              label="Quale garanzia vuoi attivare?*"
              placeholder={t("digital_journey.accident_information.select")}
              data={getVandalismSeverity(t)}
              value={vandalismSeverity}
              onChange={(value) => setVandalismSeverity(value as VandalismSeverity)}
            />
          </Flex>
        </Box>
      </Flex>
      <Flex px={24} py={24} gap={16}>
        <Button disabled={isDisabled} onClick={onContinue}>
          {continueCTA}
        </Button>
      </Flex>
    </PageLayout>
  );
};
